import { toggleColorMode } from '@lib/store';
import { useAppDispatch, useAppSelector } from '@lib/store/hooks';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

import { Button } from './button';

interface ThemeToggleProps {
  labeled?: boolean;
  iconOnly?: boolean;
}

export const ThemeToggle = ({
  labeled = false,
  iconOnly = false,
}: ThemeToggleProps): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const mode = useAppSelector((state) => state.colorMode.mode);
  const isDark = mode === 'dark';
  const label = isDark ? t('theme.switchToLight') : t('theme.switchToDark');

  if (iconOnly) {
    return (
      <IconButton
        aria-label={label}
        title={label}
        onClick={() => dispatch(toggleColorMode())}
        sx={{ color: 'text.secondary' }}
      >
        {isDark ? (
          <LightModeOutlinedIcon sx={{ fontSize: 22 }} />
        ) : (
          <DarkModeOutlinedIcon sx={{ fontSize: 22 }} />
        )}
      </IconButton>
    );
  }

  return (
    <Button
      type="button"
      variant="outlined"
      aria-label={label}
      title={label}
      onClick={() => dispatch(toggleColorMode())}
      startIcon={
        isDark ? (
          <LightModeOutlinedIcon sx={{ fontSize: 18 }} />
        ) : (
          <DarkModeOutlinedIcon sx={{ fontSize: 18 }} />
        )
      }
      sx={{ borderRadius: 999 }}
    >
      {labeled ? (isDark ? t('theme.light') : t('theme.dark')) : null}
    </Button>
  );
};
